import script from "./InvestorDashboardView.vue?vue&type=script&setup=true&lang=js"
export * from "./InvestorDashboardView.vue?vue&type=script&setup=true&lang=js"

import "./InvestorDashboardView.vue?vue&type=style&index=0&id=524cd91c&scoped=true&lang=css"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-524cd91c"]])

export default __exports__